export default {
  getNewUser(state) {
    return state.NewUser;
  },
  getUsers(state) {
    return state.users;
  },
};
